// ANCHOR React
import React, { memo } from 'react';

// ANCHOR Base
import { Block } from 'baseui/block';

// ANCHOR Models
import { ProviderData } from '@lyon/scoped-models/ProviderData';
import { CourseCardData } from '@lyon/scoped-models/CourseCardData';

// ANCHOR Components
import { LyonCourseCardHeader } from './LyonCourseCardHeader';
import { LyonCourseCardBody } from './LyonCourseCardBody';

// ANCHOR Styles
import { BLOCK } from './styes';

export const LyonCourseCardContainer = memo(() => {
  const providerId = CourseCardData.useSelector(({ data }) => data?.providerId);

  return (
    <Block overrides={BLOCK}>
      <ProviderData.Provider id={providerId}>
        <LyonCourseCardHeader />
        <LyonCourseCardBody />
      </ProviderData.Provider>
    </Block>
  );
});
